import { useAtomValue } from "jotai";
import { devices } from "library/constants";
import { ECompanyContentTab } from "library/types";
import { employerContentTabAtom } from "store/UIEmployerPage";
import styled from "styled-components";

import { CollapseWrapper } from "components/effects/CollapseWrapper";

import { EmployerDocuments } from "./EmployerDocuments";

export function EmployerContent() {
  const selectedContentTab = useAtomValue(employerContentTabAtom);

  return (
    <Container>
      <CollapseWrapper visible={selectedContentTab === ECompanyContentTab.details}>
        <>TODO</>
      </CollapseWrapper>
      <CollapseWrapper visible={selectedContentTab === ECompanyContentTab.documents}>
        <EmployerDocuments />
      </CollapseWrapper>
    </Container>
  );
}

const Container = styled.div`
  box-sizing: border-box;
  padding: 1px;
  margin-top: 10px;
  @media only screen and ${devices.md} {
  }
`;
